export default __webpack_public_path__ + "static/media/open-vault.d221f849.mp4";